import {getBaseProductCodeUsingRangePrefix} from './getBaseProductCodeUsingRangePrefix';

export default {
    getBaseProductCodeUsingRangePrefix
}